import { createSlice } from "@reduxjs/toolkit";
import axios, { API_ENDPOINTS } from "src/utils/axios";

export const initialState = {
        read_access: true,
        write_access: true,
        access: true
  };

  const slice = createSlice({
    name: "access_rights",
    initialState,
    reducers: {
      resetAccessRights(state) {
        state.read_access = true;
        state.write_access = true;
        state.access = true;
      },
      denyAccessRights(state) {
        state.read_access = false;
        state.write_access = false;
        state.access = false;
      },
      setReadAccess(state, action){
        state.read_access = action.payload;
        state.access = action.payload;
      },
      setWriteAccess(state, action){
        state.write_access = action.payload;
        state.access = action.payload;
      },
    },
  });

  export const { resetAccessRights, setReadAccess, setWriteAccess, denyAccessRights } = slice.actions;

export default slice.reducer;

export function getPermissions(check_permission, permission_type) {

    return async (dispatch) => {
      const permissions = [false, true];
      try {
        const response = await axios.get(
            API_ENDPOINTS.checkpermission,{
                params:{
                    check_permission,
                    permission_type
        }});
        const _permission = response.data ? Object.keys(response.data):[];
        if(_permission.includes('write_access'))dispatch(slice.actions.setWriteAccess(permissions[parseInt(response.data['write_access'])]));    
        if(_permission.includes('read_access'))dispatch(slice.actions.setReadAccess(permissions[parseInt(response.data['read_access'])]));
    
      } catch (error) {
        dispatch(slice.actions.denyAccessRights());
      }
    };
  }